import { render, staticRenderFns } from "./BlockedQuestBanner.vue?vue&type=template&id=39a83791&"
import script from "./BlockedQuestBanner.vue?vue&type=script&lang=js&"
export * from "./BlockedQuestBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports